import { formatMoney } from 'accounting'

import { Box, Text } from '@domain-group/suit-theme'

import type { UseOrderApprovalPayload } from '@modals/ApproveOrderModal/hooks/useOrderApproval'

type TotalProps = {
  orderApprovalPayload: UseOrderApprovalPayload,
}

const Total = (props: TotalProps) => {
  const {
    orderApprovalPayload: {
      order: { total },
      processingFees,
    },
  } = props

  return (
    <Box alignItems="center" borderTop="1px dashed" borderColor="lineColor" marginTop="large" paddingTop="large">
      <Text>Total</Text>

      <Box flexDirection="column" marginLeft="auto" textAlign="right" width="auto">
        <Text>{formatMoney(total)}</Text>

        {processingFees > 0 && (
          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
            + {formatMoney(processingFees)} Fees
          </Text>
        )}
      </Box>
    </Box>
  )
}

export default Total
